import { render, staticRenderFns } from "./KitTab.vue?vue&type=template&id=45417228&scoped=true&"
import script from "./KitTab.vue?vue&type=script&lang=js&"
export * from "./KitTab.vue?vue&type=script&lang=js&"
import style0 from "./KitTab.vue?vue&type=style&index=0&id=45417228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45417228",
  null
  
)

export default component.exports